import { render, staticRenderFns } from "./twitter.vue?vue&type=template&id=a61bf0c6&scoped=true&"
import script from "./twitter.vue?vue&type=script&lang=js&"
export * from "./twitter.vue?vue&type=script&lang=js&"
import style0 from "./twitter.vue?vue&type=style&index=0&id=a61bf0c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61bf0c6",
  null
  
)

export default component.exports